module.exports = __webpack_public_path__ + "assets/img/34_704.c5052a94.jpg";